<template>
  <div class="flex flex-col gap-4">
    <span>{{ label }}</span>
    <div class="flex gap-4 items-center">
      <font-awesome-icon
        v-for="icon in iconList"
        :key="icon[1]"
        class="text-accent-500 cursor-pointer hover:text-success-500"
        :class="{ '!text-success-400': isIconSelected(icon[1]) }"
        :rotation="getIconRotation(icon[1]) || undefined"
        :icon="icon"
        @click="$emit('iconSelected', icon[1])"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
const props = defineProps({
  iconList: {
    type: Array<Array<String>>,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  selected: {
    type: String,
    required: true,
  },
});

defineEmits(["iconSelected"]);

const isIconSelected = (val: String) => {
  return props.selected === val;
};

const getIconRotation = (icon: String) => {
  return icon === "bars-progress" ? 270 : null;
};
</script>
